import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bootstrapLaborClassifications } from './laborClassificationsOperations';

/**
 * Refetches the global Labor Classifications cache (`?includeDeleted=true`)
 * every time the calling page mounts. Mount on the root of each page that
 * consumes LC data so that route changes — including pages left idle for
 * hours — re-pull the latest names and soft-delete state.
 */
const useBootstrapLaborClassifications = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(bootstrapLaborClassifications());
  }, [dispatch]);
};

export default useBootstrapLaborClassifications;
